import { format } from 'date-fns';

/**
 * Formats a follow-up timestamp for display. The time-of-day is significant
 * (reps schedule follow-ups around calls), so it is shown — except for
 * midnight, which is what date-only picks (and every follow-up recorded
 * before the time picker existed) resolve to; rendering those as "12:00 AM"
 * would read as a deliberate time when none was chosen.
 */
export function formatFollowUpTime(date: Date): string | null {
  if (date.getHours() === 0 && date.getMinutes() === 0) return null;
  return format(date, 'h:mm a');
}
